import {
  FunctionsHttpError,
  FunctionsRelayError,
  FunctionsFetchError,
} from '@supabase/supabase-js';
import { TFunction } from 'i18next';

export const extractErrorMessageFromResponse = async (error: unknown, t: TFunction) => {
  let errorMessage = '';
  if (error instanceof FunctionsHttpError) {
    const errorPayload = await error.context.json();
    if (error.context.status === 429) {
      errorMessage = t('common.too_many_requests');
    } else {
      const { error: errorMsg, message } = errorPayload;
      errorMessage = message || errorMsg || t('common.error_occurred');
    }
  } else if (error instanceof FunctionsRelayError) {
    errorMessage = error.message;
  } else if (error instanceof FunctionsFetchError) {
    errorMessage = error.message;
  }
  return errorMessage;
};
